import InnerGardenFlow from "@/components/Exercises/InnerGarden/InnerGardenFlow";
import { Button } from "@/components/ui/button";
import { ExerciseLayout } from "@/components/ui/exercise-layout";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { FormattedMessage } from "react-intl";

export const Route = createFileRoute(
  "/(content)/adults/exercises/(shared)/inner-garden/",
)({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    referrer: search?.referrer as string | undefined,
    referrerGroup: search?.referrerGroup as string | undefined,
  }),
  head: () => ({
    meta: [
      {
        title: "Inner Garden Exercise - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "innerGarden.title",
    navbar: {
      showTitle: true,
    },
  }),
});

// TODO: add the intro MediaPlayer (see baggage/index.tsx) once the intro audio is recorded
function RouteComponent() {
  const [showOverlay, setShowOverlay] = useState(false);

  return (
    <ExerciseLayout
      contentClassName="py-7.5 space-y-18"
      actions={
        <Button className="w-full" onClick={() => setShowOverlay(true)}>
          <FormattedMessage id="common.startExercise" />
        </Button>
      }
    >
      <p className="text-small text-dark">
        <FormattedMessage id="innerGarden.intro" />
      </p>
      <InnerGardenFlow
        isShow={showOverlay}
        onComplete={() => setShowOverlay(false)}
        onExit={() => setShowOverlay(false)}
      />
    </ExerciseLayout>
  );
}
